module.exports = __webpack_public_path__ + "assets/shake-glass-0.e2ebb339.svg";